import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
const ApptDesc = ({ byRoute, className }) => {
    var _a;
    const { status, actions } = byRoute;
    let description = ((_a = status.texts) === null || _a === void 0 ? void 0 : _a.desc) || [];
    let params = { forms: [] };
    if (actions.fillForms && status.formsNotFilled.any) {
        params.forms = [
            _jsx(Trans, { i18nKey: "appt_desc.forms", components: [_jsx("span", { className: "a", onClick: () => { var _a; return (_a = actions.fillForms) === null || _a === void 0 ? void 0 : _a.action(); } })] }),
        ];
    }
    description = description
        .map((x) => (params.hasOwnProperty(x) ? params[x] : x))
        .reduce((r, a) => r.concat(a, ' '), []);
    if (!description.length) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ className: classNames(className) }, { children: description.map((item, index) => (_jsx(Fragment, { children: item }, index))) })));
};
export default observer(ApptDesc);
